<section class="pageWrapper">
  <header id="main_logo" class="d-none d-xl-block d-md-block brandBlueBackground">
    <div class="container">
      <nav class="navbar navbar-expand-lg p-0">
        <div class="navbar-brand d-inline">
          <a routerLink="/dashboard">
            <img src="../../../assets/new-dash/logo/revenuedLogo.svg" class="img-fluid d-inline" alt="Revenued Logo" />
          </a>
        </div>
      </nav>
    </div>
  </header>

  <div style="height: auto; padding-bottom: 0 !important;" class="commonBrandBg contentCard">
    <div id="wrapper">
      <div id="content">
        <div class="container p-0">
          <div id="ac_summary" class="d-flex justify-content-center ">
            <div class="container d-md-block d-lg-block d-xl-block">
              <div class="card card1">
                <div class="summaryHeadingWrapper">
                  <!-- Loading State -->
                  <div *ngIf="isLoading" class="loading-container">
                    <div class="loading-spinner"></div>
                    <p>Loading offer options...</p>
                  </div>

                  <!-- Content loaded from API -->
                  <div *ngIf="!isLoading">
                    <h1 class="summary-heading text-uppercase primaryPageHead">
                      {{ titleContent }}
                    </h1>
                    <div class="summary-subheading" [innerHTML]="subTitleContent"></div>

                    <!-- API Error indicator (optional) -->
                    <div *ngIf="apiError" class="api-error-notice">
                      <small class="text-muted">Using fallback data due to API unavailability</small>
                    </div>
                  </div>
                </div>

                <div class="offers-comparison-container">
                  <div class="viewport-wrapper">

                    <!-- Desktop View -->
                    <div class="table-container desktop-table">
                      <div class="comparison-table-wrapper">
                        <table class="comparison-table">
                          <thead>
                            <tr>
                              <th class="category-header">Financing Type</th>
                              <th class="sbf-header">Sales-Based Financing<br><span class="sub-header">(SBF)</span></th>
                              <th class="cfl-header">Commercial Loan Facility<br><span class="sub-header">(CFL)</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of comparisonData; let i = index"
                              [ngClass]="{'highlight-row': row.highlight}">
                              <td class="category-cell">{{ row.category }}</td>
                              <td class="sbf-cell">
                                <span [innerHTML]="row.sbf"></span>
                              </td>
                              <td class="cfl-cell">
                                <span [innerHTML]="row.cfl"></span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Mobile Card View -->
                    <div class="mobile-cards">
                      <div *ngFor="let row of comparisonData; let i = index" class="comparison-card"
                        [ngClass]="{'highlight-card': row.highlight}">
                        <div class="card-header">
                          <h3 class="category-title">{{ row.category }}</h3>
                        </div>
                        <div class="card-content">
                          <div class="option-item sbf-option">
                            <h4 class="option-title">SBF</h4>
                            <div class="option-content">
                              <span [innerHTML]="row.sbf"></span>
                            </div>
                          </div>
                          <div class="option-item cfl-option">
                            <h4 class="option-title">CFL</h4>
                            <div class="option-content">
                              <span [innerHTML]="row.cfl"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <p class="note" *ngIf="!isLoading && specialNoteContent">
                      {{ specialNoteContent }}
                    </p>

                    <h3 class="summary-subheading text-left mt-2 mb-0" *ngIf="!isLoading && applyQuestionContent">
                      {{ applyQuestionContent }}
                    </h3>

                    <!-- Disclosure checkbox -->
                    <mat-checkbox class="optinCheckbox mt-3" [checked]="isOptInChecked" required
                      (change)="toggleOptInCheckbox()" *ngIf="!isLoading && disclosureContent">
                      <span [innerHTML]="disclosureContent"></span>
                    </mat-checkbox>

                    <div class="actionBtns" mat-dialog-actions *ngIf="!isLoading">
                      <ion-button class="primary-general-btn whiteBtn" mat-ripple cdkFocusInitial>
                        <span>
                          {{ continueSbfBtnContent || 'Continue with SBF' }}
                        </span>
                      </ion-button>
                      <ion-button class="primary-general-btn" mat-ripple [disabled]="isButtonDisabled()"
                        [ngClass]="{ 'disabled-btn': isButtonDisabled() }">
                        {{ continueClfBtnContent || 'Apply for CLF' }}
                      </ion-button>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
  <section id="footer">
    <app-footer noAuth="true"></app-footer>
  </section>
  <div class="md-hide splash-screen">
    <h4 style="color: #fff; font-weight: 300;">For a better experience</h4>
    <h2 style="color: #fff;">Please switch to portrait orientation.</h2>
  </div>
</section>

<div class="offers-comparison-container" *ngIf="false">
  <div class="viewport-wrapper">
    <!-- Header Section -->
    <header class="comparison-header">
      <div class="header-content">
        <div class="description-wrapper">
          <p class="subtitle">
            We have your offer options! In addition to a SBF we also have an alternative loan product from affiliate
            entity.
          </p>
          <p class="description">
            Below explains differences between the products, pros and cons and other details.
          </p>
        </div>
      </div>
    </header>

    <!-- Main Content Area -->
    <main class="main-content">
      <!-- Desktop Table View -->
      <div class="table-container desktop-table">
        <div class="comparison-table-wrapper">
          <table class="comparison-table">
            <thead>
              <tr>
                <th class="category-header">Financing Type</th>
                <th class="sbf-header">Sales-Based Financing<br><span class="sub-header">(SBF)</span></th>
                <th class="cfl-header">Commercial Loan Facility<br><span class="sub-header">(CFL)</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of comparisonData; let i = index" [ngClass]="{'highlight-row': row.highlight}">
                <td class="category-cell">{{ row.category }}</td>
                <!-- <td class="sbf-cell">
                  <span *ngIf="!row.sbfLink">{{ row.sbf }}</span>
                  <a *ngIf="row.sbfLink" target="_blank"
                    href="https://app-uat.revenued.com/pricing?oppId=006UQ00000ELEuWYAX" class="pricing-link">
                    {{ row.sbf }}
                  </a>
                </td>
                <td class="cfl-cell">
                  <span *ngIf="!row.cflLink">{{ row.cfl }}</span>
                  <a *ngIf="row.cflLink" target="_blank"
                    href="https://cf-offers-uat.revenued.com/pricing?oppId=0064X00002Hi6c5" class="pricing-link">
                    {{ row.cfl }}
                  </a>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Mobile Card View -->
      <div class="mobile-cards">
        <div *ngFor="let row of comparisonData; let i = index" class="comparison-card"
          [ngClass]="{'highlight-card': row.highlight}">
          <div class="card-header">
            <h3 class="category-title">{{ row.category }}</h3>
          </div>
          <div class="card-content">
            <!-- <div class="option-item sbf-option">
              <h4 class="option-title">SBF</h4>
              <div class="option-content">
                <span *ngIf="!row.sbfLink">{{ row.sbf }}</span>
                <a *ngIf="row.sbfLink" href="#" class="pricing-link"
                  (click)="onPricingLinkClick('sbf'); $event.preventDefault()">
                  {{ row.sbf }}
                </a>
              </div>
            </div>
            <div class="option-item cfl-option">
              <h4 class="option-title">CFL</h4>
              <div class="option-content">
                <span *ngIf="!row.cflLink">{{ row.cfl }}</span>
                <a *ngIf="row.cflLink" href="#" class="pricing-link"
                  (click)="onPricingLinkClick('cfl'); $event.preventDefault()">
                  {{ row.cfl }}
                </a>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </main>

    <!-- Footer Action Section -->
    <footer class="action-section">
      <p class="action-text">
        Make your pick and if you want the loan we'll submit your application to them on your behalf!
      </p>
      <button type="button" class="selection-button" (click)="onMakeSelection()">
        Make Your Selection
      </button>
    </footer>
  </div>
</div>
